module.exports = __webpack_public_path__ + "static/img/20211012_2.9baaf0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021/20211012_2.png
// module id = rka1
// module chunks = 0